import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ComplexGuide.module.scss";
import Header from "../../components/Header/Header";
import MenuBar from "../../components/MenuBar/MenuBar";
import Footer from "../../components/Footer/Footer";
import Bener from "../../components/Bener/Bener";
import FixIcon from "../../components/FixIcon/FixIcon";
import { Helmet } from "react-helmet-async";


import page1 from "../../assets/ComplexGuide/ComplexGuide2/page1.webp";



const ComplexGuide1 = () => {
  const menuContents = [
    { title: "단지 배치도", url: "/ComplexGuide/intro" },
    { title: "호수 배치도", url: "/ComplexGuide/detailintro" },
    { title: "커뮤니티", url: "/ComplexGuide/community" },
  ];
  const [isScroll, setIsScroll] = useState(false);
  const [isImage2Loaded, setIsImage2Loaded] = useState(false); // 이미지 로딩 상태 추가
  const { pathname } = useLocation(); // 현재 경로를 가져옴

  // 이미지가 로드되면 호출되는 함수
  const handleImageLoad = () => {
    setIsImage2Loaded(true); // 이미지가 로드되면 상태 업데이트
  };

  useEffect(() => {
    window.scrollTo(0, 0); // 페이지가 로드될 때 스크롤을 최상단으로 이동
  }, [pathname]); // pathname이 변경될 때마다 실행

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.container}>
    <Helmet>
      {/* 기본 설정 */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="robots" content="index, follow" />
      <html lang="ko" />

      {/* SEO 핵심 */}
      <title>모종 삼일 파라뷰- 호수배치도</title>
      <meta
        name="description"
        content="모종 삼일 파라뷰호수배치도를 통해 동별 세대 위치와 배치 구조를 확인하세요."
      />
      <meta
        name="keywords"
        content="모종 삼일 파라뷰, 호수배치도, 세대배치, 동호수 안내, 아산 모종 아파트"
      />
      <link rel="canonical" href="https://www.a7lashare.com/ComplexGuide/detailintro" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ko_KR" />
      <meta property="og:site_name" content="모종 삼일 파라뷰" />
      <meta property="og:title" content="모종 삼일 파라뷰- 호수배치도" />
      <meta
        property="og:description"
        content="모종 삼일 파라뷰호수배치도에서 세대 위치와 배치 구조를 한눈에 확인하세요."
      />
      <meta property="og:url" content="https://www.a7lashare.com/ComplexGuide/detailintro" />
      <meta property="og:image" content="https://www.a7lashare.com/Main1.png" />
      <meta property="og:image:alt" content="모종 삼일 파라뷰호수배치도" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="모종 삼일 파라뷰- 호수배치도" />
      <meta
        name="twitter:description"
        content="모종 삼일 파라뷰호수배치도를 통해 세대 위치와 동호수 배치를 확인하세요."
      />
      <meta name="twitter:image" content="https://www.a7lashare.com/Main1.png" />
      <meta name="twitter:url" content="https://www.a7lashare.com/ComplexGuide/detailintro" />
    </Helmet>

    <Header isChanged={isScroll} />
    <FixIcon />

    <Bener title="단지안내" />
    <MenuBar contents={menuContents} />

    <h1 className={styles.screenReaderOnly}>
      모종 삼일 파라뷰- 호수배치도
    </h1>
    <p className={styles.screenReaderOnly}>
      호수배치도 페이지는 모종 삼일 파라뷰의 세대별 위치와 배치 구조를 안내합니다.
      각 동과 호수의 배치를 통해 세대 선택 시 참고할 수 있는 정보를 제공합니다.
    </p>

    <div className={styles.textBox}>
      <div>세대 선택을 위한 배치 정보</div>
      <div>모종 삼일 파라뷰호수배치도</div>
    </div>


      {/* 이미지에 애니메이션 효과 추가 */}
      <img
				className={`${styles.image2} ${isImage2Loaded ? styles.showImage2 : ''}`}
				src={page1}
				alt="모종 삼일 파라뷰호수배치도-image1"
				onLoad={handleImageLoad}  // 이미지 로드 후 애니메이션 실행
			/>

    
    
      <div className={styles.commonBox}>
        <div className={styles.notice}>
          ※ 상기 호수배치도 이미지는 소비자의 이해를 돕기 위한 것으로 실제와
          차이가 날 수 있습니다
        </div>
        <div className={styles.notice}>
          ※ 단지 내 조경 및 세부 식재계획, 시설물의 위치는 실제 시공시 현장
          상황에 따라 변경될 수 있습니다
        </div>
        
      </div>

      <Footer />
    </div>
  );
};

export default ComplexGuide1;
